import { useCreateMachine } from 'fsm';
import { machine } from './machine';
import { useAlerts } from 'breeze-intelligence-kit';
import { useCurrentUser } from 'policy-lib';
import { BulkEnrichmentContext } from './context';
import { useEnrichmentSettings } from '../../EnrichmentSettingsProvider';
import { useEnrichableObjectTypes } from '../../EnrichableObjectTypesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const BulkEnrichmentProvider = ({
  children,
  onDone,
  onLogging,
  objectTypeId,
  selectionIds
}) => {
  const currentUser = useCurrentUser();
  const {
    isLoaded: isSettingsLoaded
  } = useEnrichmentSettings();
  const {
    addAlertDanger,
    addAlertSuccess
  } = useAlerts();
  const {
    companyLabelLowercase,
    companyLabelPluralLowercase,
    contactLabelLowercase,
    contactLabelPluralLowercase
  } = useEnrichableObjectTypes();
  const initialContext = {
    addAlertDanger,
    addAlertSuccess,
    companyLabelLowercase,
    companyLabelPluralLowercase,
    contactLabelLowercase,
    contactLabelPluralLowercase,
    currentUser,
    enrichAssociations: false,
    objectTypeId: objectTypeId,
    onDone,
    onLogging,
    shouldOverwrite: true,
    selectionIds
  };
  const bulkEnrichmentMachine = useCreateMachine(machine, {
    initialContext,
    isReady: currentUser.isLoaded && isSettingsLoaded
  });
  return /*#__PURE__*/_jsx(BulkEnrichmentContext.Provider, {
    value: bulkEnrichmentMachine,
    children: children
  });
};